module.exports = __webpack_public_path__ + "static/media/flag-ceb.0de680dd.webp";